import esMessages from '../locales/es_ES.json';
import merchandisingMessages from '../locales/merchandising';

const EsLang = {
  messages: {
    ...merchandisingMessages,
    ...esMessages,
  },
  locale: 'es',
};
export default EsLang;
